/**
 * @generated SignedSource<<16b5b78ac4c3b44addc975bfa1e50126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OpportunitiesTab_userProfile$data = {
  readonly displayUsername: string;
  readonly " $fragmentType": "OpportunitiesTab_userProfile";
};
export type OpportunitiesTab_userProfile$key = {
  readonly " $data"?: OpportunitiesTab_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"OpportunitiesTab_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OpportunitiesTab_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "278370dfa09636684d5a9c4284c4ef6a";

export default node;
